import { BaseChart } from "src/app/core/data/model";
import { BlocState } from "../base-bloc";

export abstract class ChartsCardState extends BlocState {
}

export class ChartsCardReadyState<ChartData extends BaseChart> extends ChartsCardState {
  constructor(public data : ChartData){
    super()
  }
}
